<template>
  <g>
    <g clip-path="url(#clip0_15_1258)">
      <path
        d="M10.23 1.75024C9.64001 1.16024 8.69001 1.16024 8.11001 1.75024L1.75001 8.11024C1.16001 8.70024 1.16001 9.65024 1.75001 10.2302L13.77 22.2502C14.36 22.8402 15.31 22.8402 15.89 22.2502L22.25 15.8902C22.84 15.3002 22.84 14.3502 22.25 13.7702L10.23 1.75024ZM14.12 20.4802L3.52001 9.88024C3.13001 9.49024 3.13001 8.86024 3.52001 8.47024L8.47001 3.52024C8.86001 3.13024 9.49001 3.13024 9.88001 3.52024L20.49 14.1302C20.88 14.5202 20.88 15.1502 20.49 15.5402L15.54 20.4902C15.15 20.8702 14.51 20.8702 14.12 20.4802ZM17.61 1.40024C16.04 0.570243 14.06 -0.029757 11.81 0.020243C11.63 0.020243 11.55 0.240243 11.67 0.370243L15.15 3.85024L16.48 2.52024C19.57 3.98024 21.82 6.89024 22.37 10.3802C22.43 10.7902 22.81 11.0702 23.23 11.0002C23.64 10.9402 23.92 10.5502 23.85 10.1402C23.25 6.34024 20.89 3.14024 17.61 1.40024ZM8.85001 20.1602L7.52001 21.4902C4.43001 20.0302 2.18001 17.1202 1.63001 13.6302C1.57001 13.2202 1.19001 12.9402 0.770013 13.0102C0.360013 13.0702 0.0800133 13.4602 0.150013 13.8702C0.750013 17.6802 3.11001 20.8802 6.39001 22.6202C7.96001 23.4502 9.94001 24.0502 12.19 24.0002C12.37 24.0002 12.45 23.7802 12.33 23.6502L8.85001 20.1602Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_1258">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000244141)"
        />
      </clipPath>
    </defs>
  </g>
</template>
